import { createFileRoute } from '@tanstack/react-router'
import { AiCostsPage } from '~/features/admin/ai-costs-page'

export const Route = createFileRoute('/admin/ai-costs')({
  component: AiCostsPage,
})
